import * as React from "react";

import {FormattedText} from "./formatted-text.tsx";

interface Props {
    isDynamic?: boolean;
    bubbleText: string;
}

/**
 * Dynamic bubbles may contain markdown, so for them we wrap in FormattedText.
 * Otherwise, just display the text to avoid unnecessary overhead.
 */
export const ActionBubbleContent = ({
    isDynamic,
    bubbleText,
}: Props): React.ReactElement => {
    return <>{isDynamic ? <FormattedText text={bubbleText} /> : bubbleText}</>;
};
